(function () {
  "use strict";

  function ensureProductSliderImageDimensions(container) {
    container.querySelectorAll("img").forEach((img) => {
      const width = img.getAttribute("width");
      const height = img.getAttribute("height");
      if (width && height && width !== "0" && height !== "0") return;

      const wrap = img.closest(".image-wrap");
      const fallbackWidth = wrap?.dataset.mediaWidth;
      const fallbackHeight = wrap?.dataset.mediaHeight;
      if (fallbackWidth && fallbackHeight) {
        img.setAttribute("width", fallbackWidth);
        img.setAttribute("height", fallbackHeight);
      }
    });
  }

  function ensureBlueLightImageDimensions() {
    document
      .querySelectorAll(".mainChooseDevice, .eyeProductsSec, .slidercCntainer")
      .forEach((container) => {
        ensureProductSliderImageDimensions(container);
      });
  }

  function initProductImageCarousels() {
    document.querySelectorAll(".slidercCntainer").forEach((container) => {
      ensureProductSliderImageDimensions(container);

      const main = container.querySelector("[class*=\"slider-content\"]");
      const thumb = container.querySelector("[class*=\"slider-thumb\"]");
      if (!main || !thumb || main.classList.contains("rm-carousel-initialized")) return;

      const mainSel = "." + Array.from(main.classList).join(".");
      const thumbSel = "." + Array.from(thumb.classList).join(".");

      new theme.Carousel(main, {
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1000,
        adaptiveHeight: true,
        arrows: true,
        dots: true,
        asNavFor: thumbSel,
      });

      new theme.Carousel(thumb, {
        slidesToShow: 4,
        slidesToScroll: 4,
        variableWidth: true,
        asNavFor: mainSel,
        focusOnSelect: true,
        arrows: false,
      });
    });
  }

  function initCarousels() {
    if (!window.theme || !theme.Carousel) return;

    ensureBlueLightImageDimensions();

    const C = theme.Carousel;

    document.querySelectorAll(".sliderEye").forEach((el) => {
      new C(el, {
        infinite: true,
        arrows: false,
        dots: true,
        speed: 300,
      });
    });

    document.querySelectorAll(".testimonial-slider").forEach((el) => {
      new C(el, {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        infinite: true,
        dots: false,
        speed: 300,
        responsive: [
          { breakpoint: 992, settings: { slidesToShow: 2, slidesToScroll: 1 } },
          { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1, dots: true } },
          { breakpoint: 0, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
      });
    });

    document.querySelectorAll(".video-carousel").forEach((el) => {
      new C(el, {
        enableBelow: 1200,
        mobileFirst: true,
        infinite: true,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "0",
        dots: true,
        draggable: true,
        responsive: [
          { breakpoint: 1200, settings: { slidesToShow: 4, slidesToScroll: 1 } },
          { breakpoint: 991, settings: { slidesToShow: 4, slidesToScroll: 1 } },
          { breakpoint: 767, settings: { slidesToShow: 3, slidesToScroll: 1 } },
          { breakpoint: 0, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
      });
    });

    document.querySelectorAll(".sliderLogo").forEach((el) => {
      new C(el, {
        enableBelow: 1410,
        mobileFirst: true,
        infinite: true,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: "0",
        dots: false,
        draggable: true,
        variableWidth: true,
        responsive: [
          { breakpoint: 1410, settings: { slidesToShow: 3, slidesToScroll: 1 } },
          { breakpoint: 991, settings: { slidesToShow: 4, slidesToScroll: 1 } },
          {
            breakpoint: 767,
            settings: { slidesToShow: 3, slidesToScroll: 1, centerMode: true },
          },
          {
            breakpoint: 0,
            settings: { slidesToShow: 1, slidesToScroll: 1, centerMode: true },
          },
        ],
      });
    });

    document.querySelectorAll(".customer_review_block").forEach((el) => {
      new C(el, {
        enableBelow: 768,
        mobileFirst: true,
        infinite: true,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "0",
        adaptiveHeight: true,
        dots: true,
        responsive: [
          { breakpoint: 767, settings: { slidesToShow: 3, slidesToScroll: 1 } },
          { breakpoint: 0, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
      });
    });

    document.querySelectorAll(".mobile-productt-slider").forEach((el) => {
      new C(el, {
        enableBelow: 1200,
        mobileFirst: true,
        infinite: true,
        arrows: true,
        swipe: true,
        dots: false,
        responsive: [
          {
            breakpoint: 1200,
            settings: { slidesToShow: 3, slidesToScroll: 1, draggable: false },
          },
          {
            breakpoint: 991,
            settings: { slidesToShow: 3, slidesToScroll: 1, draggable: false },
          },
          {
            breakpoint: 767,
            settings: { slidesToShow: 2, slidesToScroll: 1, draggable: false },
          },
          {
            breakpoint: 0,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              draggable: false,
            },
          },
        ],
      });
    });

    document.querySelectorAll(".img-slider").forEach((el) => {
      new C(el, {
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
      });
    });

    document.querySelectorAll(".mobile-product-slider").forEach((el) => {
      new C(el, {
        enableBelow: 1200,
        mobileFirst: true,
        infinite: true,
        centerMode: false,
        arrows: true,
        swipe: false,
        dots: false,
        responsive: [
          {
            breakpoint: 1200,
            settings: { slidesToShow: 3, slidesToScroll: 1, draggable: false },
          },
          {
            breakpoint: 991,
            settings: { slidesToShow: 3, slidesToScroll: 1, draggable: false },
          },
          {
            breakpoint: 767,
            settings: { slidesToShow: 2, slidesToScroll: 1, draggable: false },
          },
          {
            breakpoint: 0,
            settings: { slidesToShow: 1, slidesToScroll: 1, draggable: false },
          },
        ],
      });
    });

    document.querySelectorAll(".tab-switching-sec .panel-slider").forEach((el) => {
      new C(el, {
        enableBelow: 992,
        mobileFirst: true,
        infinite: true,
        arrows: false,
        dots: true,
        responsive: [
          { breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 1 } },
          { breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 1 } },
          { breakpoint: 0, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
      });
    });

    initProductImageCarousels();
  }

  document.addEventListener("DOMContentLoaded", initCarousels);
})();
